import React from 'react';
import { HotelHeaderCardProps } from '../types/bot.types';
import { AiFillStar } from 'react-icons/ai';
import { IoBusiness } from 'react-icons/io5';

/**
 * Slim hotel context header shown above the room option cards. Anchors which
 * hotel the rooms belong to in a chat where several hotels may be discussed.
 * Props are pre-flattened by RoomOptionsList (which probes the nested
 * hotelInfo.info.* search-result shape).
 */
const HotelHeaderCard: React.FC<HotelHeaderCardProps> = ({
  name,
  stars,
  destination,
  imageUrl,
  amenities,
}) => {
  return (
    <div className="bot-room-header">
      <div className="bot-room-header__image-wrap">
        {imageUrl ? (
          <img src={imageUrl} alt={name} className="bot-room-header__image" />
        ) : (
          <div className="bot-room-header__image-placeholder">
            <IoBusiness size={28} />
          </div>
        )}
      </div>
      <div className="bot-room-header__body">
        <div className="bot-room-header__name">{name}</div>
        {!!stars && (
          <div className="bot-room-header__stars">
            {Array.from({ length: Math.min(stars, 5) }).map((_, i) => (
              <AiFillStar key={i} color="#f5a623" />
            ))}
          </div>
        )}
        {destination && (
          <div className="bot-room-header__destination">📍 {destination}</div>
        )}
        {!!amenities?.length && (
          <div className="bot-room-header__amenities">
            {amenities.slice(0, 3).map((a, i) => (
              <span key={i} className="bot-room-header__amenity">
                {a}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default HotelHeaderCard;
